import _ from "underscore";

import { walk } from "common/components/utils/walk";

const oldSortBy = _.sortBy;

_.mixin({
    /**
     * If the value of the named property exists then return it. Otherwise just return undefined
     */
    propValue(obj, property) {
        let result = void 0;
        const _property = Array.isArray(property) ? property.join(".") : property;
        
        // eslint-disable-next-line eqeqeq
        if (obj == null) {
            return result;
        }
        
        result = walk(obj, _property);
        
        return result;
    },
    
    /**
     * https://gist.github.com/josdejong/4537647
     * Substitute properties in a string with their value.
     * Properties start with a dollar sign, and can contain nested properties,
     * by separating properties by a dot. In that case the provided object
     * Variables without matching value will be left untouched.
     *
     * Example:
     *     var msg = _.interpolate('Hello, $name!', {name: 'Jos'});
     *
     * @param {String} str     String containing properties.
     * @param {Object} props   Object with property values to be replaced.
     * @return {String} interpolatedStr
     */
    interpolate(str, props) {
        /* eslint-disable */
        return str.replace(/\$([\w\.]+)/g, (original, key) => {
            const keys = key.split(".");
            let value = props[keys.shift()];
            while (keys.length && value !== void 0) {
                const k = keys.shift();
                value = k ? value[k] : `${value}.`;
            }
            return value !== void 0 ? value : original;
        });
        /* eslint-enable */
    },
    
    getClosestIntegerInSortedArray(array, value) {
        // Binary search FTW!
        let low = 0;
        let high = array.length - 1;
        
        if (high < 0) {
            throw new Error("The array cannot be empty");
        }
        
        while (low < high) {
            const mid = Math.floor((low + high) / 2);
            const d1 = Math.abs(array[mid] - value);
            const d2 = Math.abs(array[mid + 1] - value);
            if (d2 <= d1) {
                low = mid + 1;
            } else {
                high = mid;
            }
        }
        
        return array[high];
    },
    
    deepExtend(obj) {
        const slice = Array.prototype.slice;
        
        obj = obj || {};
        
        _.each(slice.call(arguments, 1), (source) => {
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const prop in source) {
                if (!_.has(source, prop)) {
                    return;
                }
                
                if (_.isObject(obj[prop]) && _.isObject(source[prop]) && !_.isFunction(source[prop])) {
                    obj[prop] = _.deepExtend(_.clone(obj[prop]), source[prop]);
                } else {
                    obj[prop] = source[prop];
                }
            }
        });
        return obj;
    },
    
    // Allow arguments to be passed to object method in "_.result()" call
    resultPartial(object, property, fallback, args) { // Arguments that will be passed into a partial, args*
        let value;
        
        // eslint-disable-next-line eqeqeq
        if (object == null) {
            value = void 0;
        } else if (_.isFunction(object)) {
            value = object;
        } else {
            value = object[property];
        }
        
        if (value === void 0) {
            value = fallback;
        }
        return _.isFunction(value) ? value.apply(object, _.rest(arguments, 3)) : value;
    },
    
    sortBy(array, iteratee) {
        let fn = iteratee;
        if (Array.isArray(iteratee)) {
            fn = iteratee[0];
        }
        
        return oldSortBy.call(this, array, fn);
    }
});

export { _ };
